import * as React from 'react'

import {Box, Container, Flex, Grid, GridItem, Heading, Stack, Text, useToken} from '@chakra-ui/react'
import {CarouselProvider, Dot, Slider, Slide} from 'pure-react-carousel'
import {Element} from 'react-scroll'

import './index.css'

const stepsStyle = {
  marginLeft: 0,
  width: '100%',
}

const StepsImage = ({color, style}: {color: string; style?: any}) => (
  <svg
    height="auto"
    viewBox="0 0 1280 407"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{...stepsStyle, ...(style || {})}}
  >
    <path
      d="M-127.172 147.257C-127.781 146.965 -128.386 146.668 -128.992 146.364L-126.465 141.324C-125.888 141.614 -125.312 141.897 -124.736 142.173C-115.335 146.684 -105.199 149.843 -94.6059 151.559L-95.5077 157.124C-106.632 155.322 -117.289 151.999 -127.177 147.255L-127.172 147.257ZM-79.59 158.698L-79.3758 153.061C-68.8192 153.465 -57.4765 152.625 -45.6599 150.555L-44.6829 156.112C-56.8896 158.249 -68.6351 159.121 -79.59 158.698ZM-29.165 152.796L-30.5372 147.325C-20.2208 144.744 -9.57956 141.369 1.99619 137.006L3.98887 142.282C-7.7926 146.722 -18.6371 150.161 -29.1637 152.793L-29.165 152.796ZM490.089 382.645C480.766 378.172 471.499 373.043 462.545 367.4L465.553 362.63C474.324 368.156 483.403 373.18 492.529 377.56C493.512 378.031 494.497 378.497 495.486 378.955L493.112 384.069C492.101 383.601 491.095 383.124 490.093 382.644L490.089 382.645ZM507.675 390.302L509.733 385.053C518.598 388.528 527.696 391.497 536.767 393.88C538.569 394.354 540.401 394.809 542.217 395.234L540.934 400.725C539.07 400.288 537.188 399.822 535.338 399.335C526.055 396.897 516.745 393.859 507.678 390.303L507.675 390.302ZM449.392 358.596C440.084 351.992 430.946 344.684 422.229 336.87L425.992 332.671C434.549 340.342 443.523 347.517 452.656 353.995L449.393 358.593L449.392 358.596ZM556.505 403.781L557.392 398.211C568.492 399.982 579.9 400.911 591.295 400.976L591.265 406.616C579.583 406.549 567.887 405.598 556.505 403.781ZM410.716 326.033C402.581 317.992 394.705 309.35 387.3 300.348L391.657 296.769C398.939 305.622 406.685 314.119 414.683 322.024L410.716 326.033ZM18.6411 136.435L16.4533 131.235C25.9308 127.255 36.1502 122.598 47.6883 117.002L50.1517 122.077C38.5183 127.72 28.21 132.417 18.6371 136.437L18.6411 136.435ZM607.12 406.166L606.767 400.538C618.094 399.833 629.434 398.273 640.475 395.901L641.661 401.416C630.346 403.848 618.726 405.446 607.119 406.169L607.12 406.166ZM377.544 287.921C370.652 278.726 364.107 269.044 358.086 259.144L362.906 256.217C368.829 265.96 375.273 275.488 382.058 284.539L377.544 287.921ZM64.2319 115.152L61.7433 110.088C73.6777 104.232 83.6491 99.5956 93.1258 95.4931L95.3692 100.668C85.976 104.734 76.0842 109.336 64.2319 115.152ZM657.05 397.548L655.484 392.129C666.478 388.956 677.183 384.93 687.3 380.165L689.706 385.269C679.318 390.159 668.33 394.291 657.05 397.548ZM350.179 245.479C348.598 242.605 347.036 239.668 345.534 236.752C342.268 230.409 338.914 223.546 334.66 214.5L339.764 212.103C343.989 221.086 347.317 227.893 350.55 234.174C352.027 237.045 353.568 239.935 355.124 242.767L350.181 245.483L350.179 245.479ZM328.03 200.273C322.854 189.123 318.164 179.094 313.178 169.26L318.21 166.712C323.234 176.624 327.947 186.701 333.145 197.901L328.03 200.273ZM109.769 94.7131L107.703 89.465C119.439 84.851 130.216 81.2202 140.649 78.3679L142.14 83.8068C131.903 86.6079 121.313 90.1729 109.769 94.7131ZM703.805 377.965L701.018 373.062C710.988 367.399 720.375 360.917 728.916 353.787L732.532 358.117C723.732 365.461 714.066 372.14 703.804 377.968L703.805 377.965ZM305.903 155.508C299.752 144.43 293.739 135.053 287.523 126.844L292.021 123.441C298.399 131.864 304.553 141.457 310.835 152.773L305.903 155.508ZM157.197 80.2101L156.076 74.6838C168.232 72.2244 179.937 70.9818 190.863 70.9945L190.86 76.6335C180.31 76.6228 168.985 77.826 157.197 80.2101ZM744.291 347.407L740.313 343.406C747.877 335.89 754.723 327.695 760.656 319.051C761.053 318.471 761.45 317.887 761.839 317.302L766.528 320.439C766.125 321.044 765.718 321.643 765.305 322.242C759.173 331.177 752.101 339.641 744.289 347.405L744.291 347.407ZM277.68 115.007C269.61 106.223 261.198 99.1613 251.958 93.417L254.935 88.6286C264.617 94.6448 273.415 102.028 281.834 111.195L277.68 115.007ZM206.158 77.5253L206.821 71.9249C218.759 73.3432 230.176 76.4412 240.756 81.1267L238.473 86.2844C228.408 81.8257 217.534 78.8791 206.156 77.528L206.158 77.5253ZM774.816 306.885L769.889 304.137C771.952 300.436 773.962 296.551 775.865 292.585C778.768 286.536 781.549 280.029 784.129 273.243L789.403 275.25C786.766 282.181 783.922 288.834 780.951 295.025C778.999 299.094 776.934 303.085 774.814 306.884L774.816 306.885ZM789.279 258.603C792.432 248.911 795.473 238.129 798.576 225.636L804.05 226.998C800.914 239.621 797.836 250.531 794.644 260.35L789.279 258.603ZM802.205 210.445C803.669 204.116 805.11 197.655 806.506 191.41C807.575 186.629 808.678 181.687 809.785 176.832L815.286 178.088C814.182 182.931 813.081 187.868 812.013 192.642C810.614 198.898 809.169 205.368 807.701 211.719L802.204 210.448L802.205 210.445ZM813.368 161.537C814.741 155.866 816.045 150.739 817.354 145.865C818.963 139.861 820.734 133.892 822.615 128.121L827.979 129.871C826.13 135.548 824.389 141.419 822.802 147.328C821.508 152.159 820.215 157.242 818.851 162.867L813.368 161.537ZM827.877 113.221C830.734 105.727 833.854 98.452 837.143 91.596C838.788 88.168 840.507 84.7788 842.255 81.5227L847.228 84.1902C845.519 87.3723 843.84 90.6847 842.233 94.0347C839.01 100.751 835.956 107.882 833.153 115.23L827.882 113.217L827.877 113.221ZM855.004 70.8274L850.233 67.8162C856.776 57.457 863.951 48.1355 871.561 40.1114L875.656 43.9933C868.298 51.7503 861.352 60.7811 855.003 70.8301L855.004 70.8274ZM886.802 33.4452L883.16 29.1356C892.429 21.3091 902.439 15.0193 912.913 10.4389L915.177 15.6064C905.201 19.9692 895.654 25.9712 886.802 33.4452ZM1231.16 177.506C1228.71 176.329 1226.23 175.106 1223.81 173.874L1226.37 168.848C1228.75 170.062 1231.19 171.266 1233.6 172.423C1241.4 176.168 1249.47 179.67 1257.56 182.833L1255.51 188.086C1247.29 184.873 1239.09 181.312 1231.16 177.506ZM1209.9 166.389C1199.81 160.665 1189.94 154.386 1180.58 147.731L1183.85 143.136C1193.06 149.683 1202.76 155.857 1212.68 161.485L1209.9 166.389ZM1270.35 193.504L1272.17 188.166C1282.91 191.824 1293.97 195.002 1305.03 197.607L1303.74 203.098C1292.5 200.449 1281.27 197.222 1270.35 193.505L1270.35 193.504ZM1167.92 138.273C1159.71 131.843 1151.32 124.713 1141.49 115.834L1145.27 111.651C1155 120.438 1163.3 127.49 1171.4 133.836L1167.92 138.273ZM1319.19 206.381L1320.24 200.84C1331.42 202.96 1342.81 204.55 1354.1 205.57L1353.59 211.187C1342.12 210.152 1330.55 208.534 1319.19 206.379L1319.19 206.381ZM929.549 10.5028L928.043 5.06679C939.148 1.99679 950.908 0.645097 962.999 1.04763L962.814 6.68562C951.294 6.30197 940.104 7.58978 929.547 10.5055L929.549 10.5028ZM1129.92 105.197C1126.2 101.733 1122.44 98.1925 1118.8 94.7719C1114.21 90.4496 1109.46 85.9828 1104.76 81.6301L1108.59 77.4941C1113.31 81.8613 1118.07 86.3385 1122.67 90.6675C1126.3 94.0855 1130.05 97.619 1133.76 101.073L1129.91 105.199L1129.92 105.197ZM1369.35 212.254L1369.61 206.619C1380.75 207.123 1392.01 207.085 1403.06 206.502L1403.36 212.134C1392.12 212.725 1380.68 212.766 1369.35 212.254ZM1093.22 71.1061C1083.66 62.5688 1075.06 55.3885 1066.92 49.162L1070.35 44.6827C1078.6 50.9981 1087.31 58.2661 1096.98 66.9019L1093.22 71.1061ZM978.069 8.11603L978.919 2.53941C989.943 4.22734 1001.32 7.29805 1012.72 11.6712L1010.71 16.9368C999.676 12.7071 988.693 9.73829 978.07 8.11334L978.069 8.11603ZM1054.35 40.0615C1044.79 33.5654 1034.96 27.8813 1025.15 23.1729L1024.89 23.0476L1027.32 17.9609L1027.59 18.09C1037.66 22.9212 1047.73 28.7429 1057.52 35.3994L1054.35 40.0654L1054.35 40.0615Z"
      fill={color}
      fillOpacity="0.54"
    />
  </svg>
)

const Step = ({
  number,
  header,
  text,
}: {
  number: React.ReactNode
  header: React.ReactNode
  text: React.ReactNode
}) => (
  <GridItem as={Flex} direction="row" py={[6, null, 0]}>
    <Text
      fontWeight={300}
      fontSize={['12xl', null, '8xl']}
      lineHeight={[0.85, null, 'inherit']}
      color={['brand.yellow.400', null, 'white']}
    >
      {number}
    </Text>
    <Flex direction="column">
      <Text as="h3" fontWeight={500} fontSize={['xl', null, '3xl']} pb={[3, null, 8]}>
        {header}
      </Text>
      <Text fontWeight={300} fontSize="md">
        {text}
      </Text>
    </Flex>
  </GridItem>
)

const steps = [
  <Step
    key={1}
    number="1"
    header="Decyzja"
    text={
      <>
        Długotrwały stres, napięcie i poczucie braku sprawczości rodzą negatywne myśli i emocje i mogą
        prowadzić do kryzysu. Pierwszy krok do zmiany, często najtrudniejszy, to decyzja, że nie chcesz dłużej
        czekać, że uświadamiasz sobie, że nic samo się nie zmieni i że postanawiasz działać. Uznaj swoje
        wątpliwości w tej sytuacji i przyjmij, że to stan przejściowy, a potem zaplanuj dalsze kroki.
      </>
    }
  />,
  <Step
    key={2}
    number="2"
    header="Działanie"
    text={
      <>
        Możesz samodzielnie walczyć o odzyskanie dobrego samopoczucia, próbując np. ćwiczeń relaksacyjnych lub
        zmiany otoczenia. One mogą pomóc na chwilę, jednak nie usuną przyczyny. Aby poradzić sobie z trudnymi
        emocjami, warto skorzystać z pomocy specjalisty, który pozna Twoją sytuację i dobierze odpowiednią
        metodę pracy.
      </>
    }
  />,
  <Step
    key={3}
    number="3"
    header="Wytrwałość"
    text={
      <>
        Nie rezygnuj, kiedy czujesz, że Twoja motywacja spada i napotykasz na przeszkody. Jeśli już proces
        zmian się rozpoczął, wytrwaj w swojej decyzji. Skup się na korzyściach, które przyniesie zmiana w
        Twoim życiu. Spotkaj się z ludźmi, którzy wspierają Cię w tym trudnym czasie. Jeśli brakuje Ci silnej
        woli i samodyscypliny, skorzystaj z prostej umiejętności – po upadku, wstań i zacznij jeszcze raz –
        być może to będzie Twoje ostatnie podniesienie się przed osiągnięciem celu.
      </>
    }
  />,
]

const Steps = () => {
  const [yellow500] = useToken('colors', ['brand.yellow.500'])

  return (
    <Box mb={12} position="relative">
      <Element name="home-steps" />
      <Box
        position="absolute"
        left="0"
        top="0"
        width="100%"
        height="100%"
        zIndex={0}
        display={['none', null, 'block']}
      >
        <Flex marginTop="3%" height="100%" position="relative" alignItems="center" justifyContent="center">
          <StepsImage color={yellow500} />
        </Flex>
      </Box>
      <Box position="relative">
        <Box
          backgroundColor="brand.yellow.400"
          zIndex={-1}
          position="absolute"
          left="0"
          top="0"
          width="100%"
          height="100%"
        />
        <Flex
          position="absolute"
          left="0"
          top="0"
          width="100%"
          height="100%"
          zIndex={0}
          display={['block', null, 'none']}
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Box overflow="hidden" position="relative" height="100%">
            <StepsImage color={yellow500} style={{transform: 'scale(1.7)'}} />
          </Box>
        </Flex>
        <Container maxW="container.xl" zIndex={1} px={[8, null, 4]}>
          <Stack
            direction={['column', null, 'row']}
            spacing={[8, null, 4]}
            paddingTop={[12, null, 150]}
            paddingBottom={[12, null, 0]}
            alignItems="flex-start"
          >
            <Heading fontWeight={500} fontSize={['md', null, '3xl']} flex={1}>
              3 kroki do lepszego samopoczucia
            </Heading>
            <Box flex={1}>
              <Box pr={[0, null, 16]}>
                Chcesz czuć się lepiej? Chcesz żyć pełnią życia? Podpowiemy Ci, jak to zrobić. Poznaj
                techniki, dzięki którym nauczysz się lepiej wpływać na swoje wnętrze – na myśli i emocje – i w
                konsekwencji, na swoje życie.
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Box position="relative">
        <Box
          position="absolute"
          left="0"
          top="0"
          width="100%"
          height="100%"
          zIndex={-1}
          display={['none', null, 'block']}
        >
          <Box height={178} backgroundColor="brand.yellow.400" />
        </Box>
        <Container maxW="container.xl" zIndex={0} display={['none', null, 'block']}>
          <Grid templateColumns="repeat(3, 1fr)" gap={6} px={6} mb={40} paddingTop="70px">
            {steps}
          </Grid>
        </Container>
        <Container maxW="container.xl" zIndex={0} display={['block', null, 'none']} px={[8, null, 4]}>
          <CarouselProvider
            naturalSlideWidth={700}
            naturalSlideHeight={300}
            totalSlides={3}
            infinite={true}
            className="steps-carousel"
            isIntrinsicHeight={true}
            currentSlide={0}
            interval={5000}
            isPlaying={true}
          >
            <Box mb={4}>
              <Slider>
                {steps.map((step, i) => (
                  <Slide index={i} key={i}>
                    {step}
                  </Slide>
                ))}
              </Slider>
            </Box>
            <Flex direction="row" alignItems="center" justifyContent="center">
              <Stack direction="row" spacing={6}>
                {steps.map((_, i) => (
                  <Dot key={i} slide={i}>
                    <Box borderRadius="full" width="14px" height="14px" />
                  </Dot>
                ))}
              </Stack>
            </Flex>
          </CarouselProvider>
        </Container>
      </Box>
    </Box>
  )
}

export default Steps
